import React, { useEffect, useState } from 'react';
import '../Revenue.css'
import INCSUBSearchbar from '../../common/SearchBar/INCSUBSearchbar';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { getTxnReqList } from '../../../services/revenueServices';
import { setTxnReqList } from '../../../features/revenue/revenueSlice';
import ReactPaginate from 'react-paginate';
import INCSUBButton from '../../common/Button/INCSUBButton';
import { setRevenuePath } from '../../../features/revenue/revenueSlice';
import INCSUBPaymentDetails from '../paymentDetails/PaymentDetails';



function INCSUBRequestList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pageNumber, setPageNo] = useState(0);
    const [searchKey, setSearchKey] = useState('')
    const txnReqList = useSelector((state) => state.revenue.txnReqList)
    const [isFocused, setIsFocused] = useState('Income')
    const [currentPage, setCurrentPage] = useState(0);
    const [shimmer, setShimmer] = useState(false);

    const fetchRequestList = async (searchKey = '', pageNo = pageNumber) => {
        try {
            const txnData = await getTxnReqList(pageNo, searchKey);
            if (txnData.status === 200) {
                dispatch(setTxnReqList(txnData.data.data))
            } else if (txnData.status === 301) {
                toast.error("Network Error");
            } else if (txnData.status === 500) {
                toast.error("Internal server error");
            } else if (txnData.status === 401) {
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login');
            } else if (![200, 401].includes(txnData.status)) {
                toast.error(txnData.data.message)
            }
        } catch (error) {
            toast.error("Something went wrong")
        } finally {
        }
    }
    useEffect(() => {
        fetchRequestList();
    }, [])


    const handleSearch = (searchKey) => {
        setSearchKey(searchKey)
        fetchRequestList(searchKey)
    }



    const [isOpenOrderDetails, setIsSyncOrderDetails] = useState(false);
    const [paymentId, setPaymentId] = useState();
    const handleVerification = async (paymentId) => {
        setPaymentId(paymentId)
        setIsSyncOrderDetails(true);
    }

    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(0);
        const pageCount = txnReqList ? txnReqList.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setPageNo(event.selected);
            fetchRequestList(searchKey, isFocused, event.selected)
            setCurrentPage(event.selected)
            setItemOffset(event.selected);
        };


        return (

            <div className='INCSUBComplaints_list_section_container'>{
                !shimmer && txnReqList && txnReqList?.paymentRequestList && txnReqList?.paymentRequestList?.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }
            </div>


        );
    }


    return (
        <div className='INCSUBRevenue_ctn'>
            <div className='INCSUBRevenue_ctn_search_cal_btn_div'><div className='INCSUBRevenue_requestListheading'>
                <svg onClick={() => {
                        dispatch(setRevenuePath('/financialinsights'));
                    }} className='back_arrow' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 19L5 12L12 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> Payout
                    </div>
                <div className='INCSUBRevenue_ctn_search_cal'>
                    <INCSUBSearchbar width={500} height={38} backgroundColor='#fff' placeholder={'Search'} param={{ func: handleSearch }} />
                </div>

            </div>
            <div className='INCSUBRevenue_content_container'>
    
                <div className='INCSUBUser_userlist_section'>
                    {txnReqList && txnReqList?.paymentRequestList?.length > 0 ? <div className='INCSUBUser_userlist_section_table_conatiner'>
                        <table className='INCSUBuser_table'>
                            <thead className='INCSUBuser_table_head'>
                                <tr>
                                    <th>#</th>

                                    <th>User Image</th>
                                    <th>User Name</th>
                                    <th>User MobileNumber </th>
                                    <th>Amount </th>
                                    <th>UPI Id</th>
                                    <th>Pool Name</th>
                                    <th>Payment RequestId</th>
                                    {/* <th>Remarks</th> */}
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody className='INCSUBuser_table_body'>
                                {
                                    txnReqList && txnReqList?.paymentRequestList?.length > 0 && txnReqList?.paymentRequestList.map((txn, index) =>
                                        <tr>
                                            <td>{index + 1}</td>
                                       
                                            <td><div className='INCSUBProfile_image_holder'>
                                                <img src={txn.userImage ? txn.userImage : '/assets/icons/common/defaultImage.png'} alt='/' />
                                            </div>
                                            </td>
                                            <td>{txn.userName}</td>
                                            <td>{txn.userMobileNumber}</td>
                                            <td>₹ {txn.amount}</td>
                                            <td>{txn.upiId}</td>
                                            <td>{txn.poolName}</td>
                                                 <td>{txn.paymentRequestId}</td>
                                            <td><div className='INCSUBRevenue_listui_ctn_rowHeading_Amount' style={{ color: 'rgba(32, 34, 36, 1)', fontWeight: 500 }}>
                                                <INCSUBButton text='Verify' clickFun={() => handleVerification(txn.paymentRequestId)} />
                                            </div></td>

                                        </tr>)
                                }
                            </tbody>
                        </table>
                    </div> : <div className='INCSUBRevenue_empty'>No Data Available</div>}
                </div>
                <PaginatedItems />
                {
                    isOpenOrderDetails && paymentId ? <INCSUBPaymentDetails onClose={setIsSyncOrderDetails} orderId={paymentId} /> : null
                }
            </div>
        </div>
    )
}

export default INCSUBRequestList;
